var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_705_5791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 9.375L12 3.25C11.7918 3.03979 11.5153 2.91085 11.2204 2.88641C10.9256 2.86196 10.6317 2.94362 10.3917 3.11667L7.64167 5.075C7.41648 5.22871 7.1472 5.30457 6.87489 5.29103C6.60258 5.27749 6.34217 5.17529 6.13333 5L0.625 0.625",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.375H18.125V4.375",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.0417H1.25C0.904822 16.0417 0.625 16.3216 0.625 16.6667V18.7501C0.625 19.0953 0.904822 19.3751 1.25 19.3751H7.5C7.84518 19.3751 8.125 19.0953 8.125 18.7501V16.6667C8.125 16.3216 7.84518 16.0417 7.5 16.0417Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.0417H11.25C10.9048 16.0417 10.625 16.3216 10.625 16.6667V18.7501C10.625 19.0953 10.9048 19.3751 11.25 19.3751H17.5C17.8452 19.3751 18.125 19.0953 18.125 18.7501V16.6667C18.125 16.3216 17.8452 16.0417 17.5 16.0417Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.7083H12.5C12.1548 12.7083 11.875 12.9881 11.875 13.3333V15.4166C11.875 15.7618 12.1548 16.0416 12.5 16.0416H18.75C19.0952 16.0416 19.375 15.7618 19.375 15.4166V13.3333C19.375 12.9881 19.0952 12.7083 18.75 12.7083Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.7083H2.5C2.15482 12.7083 1.875 12.9881 1.875 13.3333V15.4166C1.875 15.7618 2.15482 16.0416 2.5 16.0416H8.75C9.09518 16.0416 9.375 15.7618 9.375 15.4166V13.3333C9.375 12.9881 9.09518 12.7083 8.75 12.7083Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.375H1.25C0.904822 9.375 0.625 9.65482 0.625 10V12.0833C0.625 12.4285 0.904822 12.7083 1.25 12.7083H7.5C7.84518 12.7083 8.125 12.4285 8.125 12.0833V10C8.125 9.65482 7.84518 9.375 7.5 9.375Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_5791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.6924c0c786f3825095b6a30251f04978.svg";
export { ForwardRef as ReactComponent };